"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import UserCICTypeIconWrapper from "@/components/user/utils/user-cic-type/UserCICTypeIconWrapper";
import UserCICStatus from "@/components/user/utils/user-cic-status/UserCICStatus";
export default function UserPageIdentityHeaderCIC(t0) {
  const $ = _c(20);
  const {
    profile
  } = t0;
  const [cicRating, setCicRating] = useState(profile.cic);
  let t1;
  if ($[0] !== profile.cic) {
    t1 = () => {
      setCicRating(profile.cic);
    };
    $[0] = profile.cic;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== profile) {
    t2 = [profile];
    $[2] = profile;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span>NIC:</span>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== cicRating) {
    t4 = formatNumberWithCommas(cicRating);
    $[5] = cicRating;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <div className="tw-flex tw items-center tw-space-x-1">{t3}<span className="tw-text-iron-100 tw-font-semibold">{t4}</span></div>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== profile) {
    t6 = <span className="tw-ml-2 tw-h-5 tw-w-5"><UserCICTypeIconWrapper profile={profile} /></span>;
    $[9] = profile;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <div className="tw-flex tw-items-center tw-text-base tw-font-medium tw-text-iron-200">{t5}{t6}</div>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="tw-text-iron-200 tw-font-medium">Status:</span>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== cicRating) {
    t9 = <div className="tw-flex tw-items-center tw-text-base tw-font-semibold tw-space-x-1">{t8}<UserCICStatus cic={cicRating} /></div>;
    $[15] = cicRating;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t7 || $[18] !== t9) {
    t10 = <div className="tw-mb-6 tw-mt-4 tw-flex tw-flex-col sm:tw-flex-row sm:tw-flex-wrap sm:tw-space-x-6 tw-gap-y-1">{t7}{t9}</div>;
    $[17] = t7;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
}